import { render } from "./AuthPopup.vue?vue&type=template&id=3310aa16&scoped=true"
import script from "./AuthPopup.vue?vue&type=script&lang=js"
export * from "./AuthPopup.vue?vue&type=script&lang=js"

import "./AuthPopup.vue?vue&type=style&index=0&id=3310aa16&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3310aa16"]])

export default __exports__